import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 11" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#17181A"
        d="M4.116 10.168c-1.624 0-2.814-.616-3.584-1.484l.686-.882c.616.686 1.624 1.33 2.94 1.33 1.666 0 2.198-.896 2.198-1.61 0-2.408-5.53-1.078-5.53-4.41 0-1.54 1.372-2.59 3.206-2.59 1.428 0 2.534.476 3.318 1.302l-.7.854c-.7-.77-1.68-1.12-2.702-1.12-1.12 0-1.918.602-1.918 1.484 0 2.1 5.53.896 5.53 4.382 0 1.358-.924 2.744-3.444 2.744z"
      />
      <path fill="#D8D8D8" stroke="#17181A" d="M1.5 5.5h6v1h-6z" />
    </g>
  </svg>
);
const Memo = memo(SvgStrikethrough);
export default Memo;
